<template>
    <CFormInput
        :model-value="modelValue"
        :add-input-classes="addInputClasses"
        :feedback-invalid="invalidFeedback"
        :invalid="invalid"
        @update:model-value="updateValue"
        @input="inputValue"
    />
</template>

<script>
import { CFormInput } from '@coreui/vue-pro'

export default {
    name: 'DInput',
    components: { CFormInput },
    props: {
        isValid: {
            type: [Boolean, Function],
            default: null
        },
        invalidFeedback: {
            type: String,
            default: null
        },
        addInputClasses: {
            type: String,
            default: null
        },
        modelValue: {
            default: null,
            type: [String, Number]
        }
    },
    emits: ['update:modelValue', 'update:value'],
    computed: {
        invalid () {
            return this.isValid === null ? (this.invalidFeedback !== null) : !this.isValid
        }
    },
    methods: {
        updateValue (event) {
            this.$emit('update:modelValue', event)
            this.$emit('update:value', event)
        },
        inputValue (event) {
            this.$emit('update:modelValue', event.target.value)
            this.$emit('update:value', event.target.value)
        }
    }
}
</script>
